// 添加下级
<template>
  <el-dialog
    :title="visibleDialogTitle"
    :visible="visibleDialog"
    width="40%"
    :before-close="closePup"
  >
    <el-form
      ref="formDept"
      :rules="formDeptRules"
      label-position="right"
      label-width="150px"
      :model="modelDialog"
    >
      <el-form-item label="部门名称" prop="departmentName">
        <el-input
          size="mini"
          v-model="modelDialog.departmentName"
          placeholder="请输入部门名称"
          style="width: 220px"
          :minlength="1"
          :maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="当前部门" v-if="this.visibleDialogTitle === '添加部门'">
        <el-input readonly v-model="modelDialog.parentDeptName" size="mini" style="width: 220px"></el-input>

      </el-form-item>
      <el-form-item v-if="isEdit" label="上级部门">
        <el-input readonly @focus="parentEnterpriseChooseFn" size="mini" style="width: 220px" v-model="tvariable1"></el-input>
        <!-- 编辑 -->
        <div v-show="parentEnterpriseVisible">
          <el-tree

            ref="tree"
            style="max-height: 400px; overflow-y: auto"
            :data="superDeptsTree"
            @check="handleCheck"
            show-checkbox
            :check-strictly="true"
            :check-on-click-node="true"
            :highlight-current="true"
            :expand-on-click-node="false"
            node-key="corpGroupId"
            :default-expand-all="true"
            :props="defaultProps"
          >
            <div
              slot-scope="{ node, data }"
              style="width: 100%"
              :title="data.groupName"
            >
              <p
                class="name"
                style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                max-width: 100%;
                padding-right: 50px;
              "
              >
                {{ data.groupName }}
              </p>
            </div>
          </el-tree>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="closePup">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleClickAddEdit()"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  props: {
    visibleDialogTitle: String,
    visibleDialog: Boolean,
    isEdit: { type: Boolean, default: false },
    superDeptsTree: { type: Array, default: () =>[] },
    pupModel: { type: Object, default: () =>{} }
  },
  data () {
    // 这里存放数据
    return {
      parentEnterpriseVisible: false, //上级部门
      tvariable1: '', //临时变量
      oldTvariable1: '', //初始上级部门变量
      currentDept: {}, // 点击关联/修改的item（被关联方）
      deptSaasVisi: false, // 关联卡片
      defaultProps: {
        children: "childCorpGroups",
        label: "groupName"
      },
      selectNodeDeptId: undefined,
      modelDialog: {
        parentId: "",
        parentDeptName: "",
        departmentId: "",
        departmentName: ""
      },
      formDeptRules: {
        departmentName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ]
      }
    }
  },
  // 方法集合
  methods: {
    // 选择上级部门
    parentEnterpriseChooseFn() {
      this.parentEnterpriseVisible = true;
    },
    //清空设置上级部门时缓存的值
    clearValueFn() {
      this.parentEnterpriseVisible = false;
      this.tvariable1 = '';
    },
    /** 关闭弹窗 */
    closePup () {
      this.clearValueFn();
      if (this.$refs["formDept"]) {
        this.$refs["formDept"].resetFields();
      }
      this.$emit('update:visibleDialog', false)
    },
    /** 确认修改 */
    handleClickAddEdit () {
      this.$refs.formDept.validate(valid => {
        if (valid) {
          let params = {};
          params.corpGroupId = this.modelDialog.departmentId;
          params.corpParentGroupId = this.modelDialog.parentId;
          params.groupName = this.modelDialog.departmentName;
          ApiCorpMethods.OrganizationController.updateGroup(params)
            .then(res => {
              if (res.code === "0") {
                const tip = params.corpGroupId ? "编辑" : "添加";
                this.$message.success(`${tip}[${params.groupName}]成功`);
                this.closePup()
                this.$emit('refresh') //刷新数据
              } else if (res.code === '10802') {
                this.$message.error(`暂无该部门的权限，如需使用，请联系管理员修改权限范围`);
              } else {
                this.$message.error(res.description);
                this.errorDescription = res.description;
              }
            })
            .catch(error => {
              this.$message.error(error.description);
            });
        } else {
          return false;
        }
      });
    },
    /** 点击树节点 */
    handleCheck (node, all) {
      this.tvariable1 = node.groupName;
      if (node.corpGroupId !== this.selectNodeDeptId) {
        if (all.checkedKeys.length > 0) {
          this.selectNodeDeptId = node.corpGroupId;
          this.$refs.tree.setCheckedKeys([node.corpGroupId]);
        }
      } else {
        let chooseList = this.$refs.tree.getCheckedKeys();
        console.log(chooseList, node.corpGroupId,)
        if (chooseList.includes(node.corpGroupId)) {
          this.$refs.tree.setCheckedKeys([node.corpGroupId]);
        } else {
          // this.$refs.tree.setChecked(node, true); //旧
          this.$refs.tree.setCheckedKeys([]);
          this.tvariable1 = this.oldTvariable1;
        }
      }
      this.modelDialog.parentId = node.corpGroupId;
    },
    /** 查询节点 */
    getNode (tree, node) {
      for (let i = 0; i < tree.length; i++) {
        const treeNode = tree[i];
        if (treeNode.corpGroupId === node.parentId) return treeNode
        if (treeNode.childCorpGroups && treeNode.childCorpGroups.length > 0) {
          const _node = this.getNode(treeNode.childCorpGroups, node)
          if (_node) return _node
        }
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    pupModel (newVal) {
      if (newVal) {
        const _val = JSON.parse(JSON.stringify(newVal))
        this.modelDialog.parentId = _val.parentId
        this.modelDialog.parentDeptName = _val.parentDeptName
        this.modelDialog.departmentId = _val.departmentId
        this.modelDialog.departmentName = _val.departmentName
        if (this.isEdit) {
          this.$nextTick(async () => {
            const node = await this.getNode(this.superDeptsTree, _val)
            console.log('node', node);
            if (this.$refs.tree) {
              this.$refs.tree.setChecked(node, true);
              this.selectNodeDeptId = node.parentId;
              this.tvariable1 = node.groupName;
              this.oldTvariable1 = node.groupName;
            }
          });
        }
      }
    }
  },
}
</script>
<style lang='less' scoped>
/* // @import url(); 引入公共css类 */
</style>



// WEBPACK FOOTER //
// components/console/memberManage/components/addChildPup.vue